import cookies from 'browser-cookies';
import { getMainDomain } from '@sv-support-sdk/utils/src/helpers/domain';

export const AUTH_TOKEN_KEY = 'airSlate.session.token';
export const domain = `.${getMainDomain()}`;
export const fetchAuthToken = (): string | null => cookies.get(AUTH_TOKEN_KEY);
export const removeAuthToken = (): void => {
  if (domain) {
    cookies.erase(AUTH_TOKEN_KEY, { domain, samesite: '', secure: false });
  }
  cookies.erase(AUTH_TOKEN_KEY);
};
